export default "__VITE_ASSET__DzugZHEQ__"